module.exports = __webpack_public_path__ + "img/min.827729e6.svg";